import React, { useState, useEffect } from 'react';
import './App.css';
import Login from './components/Auth/Login';
import Dashboard from './components/Dashboard/Dashboard';
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy';
import AccessibilityWidget from './components/Accessibility/AccessibilityWidget';
import { DesignThemeProvider, useDesignTheme } from './context/DesignThemeContext';
import { api } from './services/api';
import { useAutoLogout } from './hooks/useAutoLogout';

function DashboardShell({ user, onLogout, sidebarOpen, onSidebarOpenChange, onOpenPrivacyPolicy }) {
  const { topNavLayout } = useDesignTheme();
  const shellSidebarOpen = sidebarOpen && !topNavLayout;

  return (
    <div className={`app-dashboard-shell${shellSidebarOpen ? ' app-dashboard-shell--sidebar-open' : ''}`}>
      <Dashboard
        user={user}
        onLogout={onLogout}
        sidebarOpen={sidebarOpen}
        onSidebarOpenChange={onSidebarOpenChange}
      />
      <footer className="app-footer app-footer--dashboard">
        <div className="app-footer-content app-footer-content--dashboard">
          <span className="app-footer-copy">
            © {new Date().getFullYear()} טרבלסי – פורטל קבלנים
          </span>
          <div className="app-footer-right">
            <div className="app-footer-contacts">
              <a href="tel:089930666" className="app-footer-contact-link" title="התקשר" aria-label="התקשר">
                <svg className="app-footer-contact-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" />
                </svg>
              </a>
              <span className="app-footer-phone">08-9930666</span>
            </div>
            <button
              type="button"
              className="app-footer-link"
              onClick={onOpenPrivacyPolicy}
            >
              מדיניות פרטיות
            </button>
          </div>
        </div>
      </footer>
    </div>
  );
}

function AppContent() {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(() => {
    if (typeof window === 'undefined') return true;
    return !window.matchMedia('(max-width: 768px)').matches;
  });

  // בדוק אם יש token שמור
  useEffect(() => {
    const userInfo = api.getUserInfo();
    if (userInfo) {
      setUser({
        username: userInfo.name,
        userCode: userInfo.userCode,
        type: userInfo.type,
        contracts: userInfo.contracts,
        dashboard: userInfo.dashboard,
      });
      setIsAuthenticated(true);
    }
  }, []);

  const handleLogin = (userData) => {
    setUser(userData);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    api.logout();
    setUser(null);
    setIsAuthenticated(false);
  };

  // ניתוק אוטומטי אחרי 2 שעות של חוסר פעילות
  useAutoLogout(handleLogout, isAuthenticated);

  return (
    <div className="App">
      <div className="app-main">
        {!isAuthenticated ? (
          <Login onLogin={handleLogin} />
        ) : (
          <DashboardShell
            user={user}
            onLogout={handleLogout}
            sidebarOpen={sidebarOpen}
            onSidebarOpenChange={setSidebarOpen}
            onOpenPrivacyPolicy={() => setShowPrivacyPolicy(true)}
          />
        )}
      </div>

      {!isAuthenticated && (
        <footer className="app-footer app-footer--login">
          <div className="app-footer-content">
            <span className="app-footer-copy">© {new Date().getFullYear()} טרבלסי – פורטל קבלנים</span>
            <button
              type="button"
              className="app-footer-link"
              onClick={() => setShowPrivacyPolicy(true)}
            >
              מדיניות פרטיות
            </button>
          </div>
        </footer>
      )}

      <AccessibilityWidget />

      {showPrivacyPolicy && (
        <PrivacyPolicy onClose={() => setShowPrivacyPolicy(false)} />
      )}
    </div>
  );
}

function App() {
  return (
    <DesignThemeProvider>
      <AppContent />
    </DesignThemeProvider>
  );
}

export default App;
